import React from 'react';
import {SelectAsyncBase} from 'components/Forms/FormBases';
import {getPublicAccreditationBodies} from 'api/accreditation-bodies';

SelectPublicAB.defaultProps = {
  placeholder: 'Select a Standard',
  isClearable: true,
  cacheOptions: true,
  defaultOptions: true,
  onChange: () => {},
  getOptionLabel: (option) => option.accreditation_bodies_name,
  getOptionValue: (option) => option.accreditation_bodies_id,
};

function SelectPublicAB(props) {
  const {value, ...rest} = props;

  async function getOptions(inputValue) {
    const query = {
      search: inputValue,
      limit: 100,
      status: 'active',
    };

    try {
      const {data} = await getPublicAccreditationBodies(query);
      return data;
    } catch (error) {
      return [];
    }
  }

  return <SelectAsyncBase loadOptions={getOptions} {...rest} />;
}

export default SelectPublicAB;
